import { AssetMaintenanceServiceBase } from './asset-maintenance.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@scisys-uim/uim-common';


@Injectable({
  providedIn: 'root'
})
export class AssetMaintenanceService extends AssetMaintenanceServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

}



